import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import PicFSUpload from '../../../../Common/picFSUpload';
import compress from '../../../../Util/jic_compress';

class DescriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: null,
      pics: [
        {
          id: null,
          original: null,
          type: null,
          oldId: null,
          description: ''
        },
        {
          id: null,
          original: null,
          type: null,
          oldId: null,
          description: ''
        }
      ]
    }
  }

  componentWillMount = () => {
    if (this.props.defaultValue) {
      this.setState({
        ...this.state, ...this.props.defaultValue
      })
    }
  };

  onFileSelected = (file, index, type = 'create', oldId = null) => {
    var that = this;
    var pics = this.state.pics;
    // FileReader function for read the file.
    var reader = new FileReader();
    var base64;
    // Onload of file read the file content
    reader.onload = function (fileLoadedEvent) {
      console.log(file)
      base64 = fileLoadedEvent.target.result.split(',')[1];
      // Print data in console
      pics[index] = { id: index, original: base64, type: type, oldId: oldId, description: file.name }
      that.setState({ pics: pics });
    }
    // Convert data to base64
    reader.readAsDataURL(file);
  };

  removePic = index => {
    var pics = this.state.pics;
    pics[index] = { id: null, type: 'delete', oldId: pics[index].id };
    this.setState({ pics: pics })
  };

  render() {
    const { isSubmitting, onClose, onSubmit } = this.props;
    return (
      <div style={styles.container}>
        <div style={styles.iconsRow}>
          <div
            className="waves-btn"
            style={[styles.iconContainer, styles.iconActive]}
            onClick={onClose}>
            <i
              className="fa fa-pencil"
              style={[styles.icon]} />
            <div style={styles.iconLabel}>Rediger</div>
          </div>
          <div style={styles.iconDivider}></div>
          <div className="waves-btn"
            style={styles.iconContainer}
            onClick={() => { onSubmit(this.state) }}>
            {isSubmitting ?
              <i
                className="fa fa-spinner fa-spin"
                style={[styles.icon]} />
              :
              <i
                className="fa fa-floppy-o"
                style={styles.icon}></i>
            }
            <div style={styles.iconLabel}>Gem</div>
          </div>
        </div>
        <div>
          <textarea
            value={this.state.text}
            onChange={evt => { this.setState({ text: evt.target.value }) }}
            ref="descriptionArea"
            rows="4"
            style={styles.textarea}
          >
          </textarea>
        </div>
        <div style={styles.picturesContainer}>
          {this.state.pics[0] && this.state.pics[0].id != null ?
            <div>
              <PicFSUpload
                accept="application/pdf"
                style={styles.uploadBtn}
                onFilesSelected={
                  (files) => {
                    if (files[0]) {
                      this.onFileSelected(files[0], 0, 'replace', this.state.pics[0].id)
                    }
                  }}
              >
                <div className="col-xs-12" style={styles.picPlaceholder}>
                  <i style={{ paddingTop: '47px' }} className="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>
                  <div>
                    {this.state.pics[0].description}
                  </div>
                </div>
                <button
                  className="btn btn-default waves-btn"
                  style={{ width: '47%' }}
                  type="button">
                  Erstat
                </button>
                <div style={styles.divider}></div>
                <div
                  style={styles.fjernBtn}
                  className="btn btn-default waves-btn"
                  onClick={(e) => {
                    this.removePic(0)
                    e.stopPropagation()
                  }}>
                  Fjern
              </div>
              </PicFSUpload>
            </div>
            :
            <div>
              <PicFSUpload
                accept="application/pdf"
                style={styles.uploadBtn}
                onFilesSelected={
                  (files) => {
                    this.onFileSelected(
                      files[0], 0)
                  }}
              >
                <div className="col-xs-12" style={styles.picPlaceholder}>
                  <i className="fa" aria-hidden="true"></i>
                </div>
                <div>
                  <button
                    style={{ 'width': '100%' }}
                    className="btn btn-default waves-btn"
                    type="button">
                    Upload
                </button>
                </div>
              </PicFSUpload>
            </div>
          }
        </div>
        <div style={[styles.picturesContainer, styles.pictureContainerRight]}>
          {this.state.pics[1] && this.state.pics[1].id != null ?
            <div>
              <PicFSUpload
                accept="application/pdf"
                style={styles.uploadBtn}
                onFilesSelected={
                  (files) => {
                    if (files[0]) {
                      this.onFileSelected(files[0], 1, 'replace', this.state.pics[1].id)
                    }
                  }}
              >
                <div className="col-xs-12" style={styles.picPlaceholder}>
                  <i style={{ paddingTop: '45px' }} className="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>
                  <div>
                    {this.state.pics[1].description}
                  </div>
                </div>
                <button
                  className="btn btn-default waves-btn"
                  style={{ width: '47%' }}
                  type="button">
                  Erstat
                </button>
                <div style={styles.divider}></div>
                <div
                  style={styles.fjernBtn}
                  className="btn btn-default waves-btn"
                  onClick={(e) => {
                    this.removePic(1)
                    e.stopPropagation()
                  }}>
                  Fjern
              </div>
              </PicFSUpload>
            </div>
            :
            <div>
              <PicFSUpload
                accept="application/pdf"
                style={styles.uploadBtn}
                onFilesSelected={
                  (files) => {
                    this.onFileSelected(
                      files[0], 1)
                  }}
              >
                <div>
                  <div className="col-xs-12" style={styles.picPlaceholder}>
                    <i className="fa" aria-hidden="true"></i>
                  </div>
                  <button
                    style={{ 'width': '100%' }}
                    className="btn btn-default waves-btn"
                    type="button">
                    Upload
                </button>
                </div>
              </PicFSUpload>
            </div>
          }
        </div>
      </div>
    )
  }
}

var styles = {
  container: {
    position: 'relative',
    zIndex: '100'
  },
  leftContainer: {
    borderRight: '1px solid',
    borderColor: semanticColors.mainBackground,
    height: '100%'
  },
  middleContainer: {
    borderRight: '1px solid',
    borderColor: semanticColors.mainBackground,
    height: '100%'
  },
  rightContainer: {
    height: '100%'
  },
  informationBoxes: {
    paddingBottom: '20px'
  },
  informationTitle: {
    fontWeight: '600',
    paddingBottom: '10px'
  },
  informationDetails: {
    paddingLeft: '10px'
  },
  picUpload: {
    height: '140px',
    width: '100%',
    border: '1px solid' + greyScaleColors.greyLighter,
    borderRadius: '2px'
  },
  coverImage: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  pencilActive: {
    color: semanticColors.info
  },
  borderActive: {
    border: '2px solid ' + semanticColors.info
  },
  img: {
    width: '100%',
    paddingBottom: '5px',
    borderRadius: '2px',
    fontSize: 50,
    textAlign: 'center',
  },
  input: {
    fontSize: '16px',
    height: '35px',
    width: '100%',
    border: 'none',
    paddingLeft: '5px',
    borderRadius: '2px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset'
  },
  textarea: {
    width: '100%',
    borderColor: greyScaleColors.greyLighter
  },
  picPlaceholder: {
    border: '1px solid' + greyScaleColors.greyLighter,
    borderRadius: '2px',
    backgroundColor: '#fff',
    color: greyScaleColors.greyLight,
    height: '140px',
    marginBottom: '10px',
    textAlign: 'center',
    lineHeight: '22px'
  },
  picturesContainer: {
    width: '50%',
    paddingRight: '12px',
    paddingTop: '10px',
    display: 'inline-block'
  },
  pictureContainerRight: {
    paddingRight: '0px',
    paddingLeft: '12px'
  },
  uploadedPictures: {
    width: '50%',
    display: 'inline-block',
    padding: '5px'
  },
  noPadding: {
    padding: '0px'
  },
  categoriesPadding: {
    padding: '0px 0px 10px 0px'
  },
  descriptionBox: {
    padding: '0px 0px 19px 0px'
  },
  fjernBtn: {
    display: 'inline-block',
    width: '48%',
    padding: '0px',
    lineHeight: '35px'
  },
  divider: {
    display: 'inline-block',
    width: '4%'
  },
  erstat: {
    display: 'inline-block',
    width: '48%',
    padding: '0px',
    lineHeight: '35px'
  },
  uploadBtn: {
    display: 'inline-block',
    width: '100%',
    padding: '0px',
    lineHeight: '35px'
  },
  projectSmallText: {
    fontSize: '12px',
    fontWeight: '500'
  },
  formLabels: {
    color: greyScaleColors.greyLight
  },
  informationDetailsEdit: {
    paddingBottom: '10px'
  },
  suggestProjectContainer: {
    width: '50%'
  },
  createProjectContainer: {
    lineHeight: '35px',
    textAlign: 'right',
    paddingRight: '38px',
    position: 'relative',
    fontSize: '12px'
  },
  createProjectPlusIcon: {
    fontSize: '20px',
    position: 'absolute',
    top: '8px',
    right: '15px'
  },
  editProjectContainer: {
    minHeight: '150px'
  },
  inputLabel: {
    fontSize: '11px'
  },
  spinner: {
    width: '20px',
    height: '20px'
  },
  iconContainer: {
    fontSize: '22px',
    height: '45px',
    width: '50px',
    padding: '0px',
    textAlign: 'center',
    float: 'right',
    zIndex: '2',
    lineHeight: '20px'
  },
  iconsRow: {
    width: '100%',
    position: 'absolute',
    top: '-50px',
    right: '0'
  },
  icon: {
    display: 'inline-block',
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  iconActive: {
    color: semanticColors.info
  },
  iconLabel: {
    fontSize: '12px',
    fontWeight: '600',
    marginTop: '-3px'
  },
  iconDivider: {
    display: 'inline-block',
    float: 'right',
    width: '1px',
    height: '30px',
    marginTop: '10px',
    marginRight: '4px',
    marginLeft: '4px',
    backgroundColor: semanticColors.mainBackground
  }
}

DescriptionForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  defaultValue: PropTypes.object
};
export default Radium(DescriptionForm)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/description/form.jsx